import { trackUmamiEvent } from "@analytics";

type AiEditImageEvent =
	| "ai-edit-image:image-uploaded"
	| "ai-edit-image:generation-started"
	| "ai-edit-image:generation-succeeded"
	| "ai-edit-image:reference-opened"
	| "ai-edit-image:reference-inserted"
	// 右栏 Examples 样片的 Create（10/28 换样片时加，用来看新样片有没有人点）
	| "ai-edit-image:showcase-clicked";

/** /image-to-image 是同一个工作台（10/20 上线），事件名照用，两页靠 url_path 区分。
 *  其他复用这个工作台的页面（营销页 hero 等）不报 */
const TRACKED_PAGES = new Set(["ai-edit-image", "image-to-image"]);

export function trackAiEditImageEvent(
	pathname: string,
	event: AiEditImageEvent,
	data?: Record<string, unknown>,
) {
	const lastSegment = pathname.split("/").filter(Boolean).at(-1);
	if (!lastSegment || !TRACKED_PAGES.has(lastSegment)) {
		return;
	}

	void trackUmamiEvent(event, data);
}
